export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_08.d2fe3536.jpg";